import { csx } from '@vtex/admin-ui'
import React, { useRef, useState } from 'react'
import { useIntl } from 'react-intl'

import { InStoreList, InStoreListItem } from '../InStoreList'
import { List } from '../../shared/types'
import type { DragData } from '../../shared/types'
import { useInStoreLists } from '../../hooks/useInStoreLists'
import type { ListsItem } from '../../context/TurnListProvider'
import { usePositionsLists } from '../../states'
import { useShowArrows } from '../../hooks/useShowArrows'

export const InServiceList = () => {
  const { inServicePositions } = usePositionsLists()
  const intl = useIntl()

  const {
    moveInServiceListItemToWaitingList,
    moveWaitingListItemToInServiceList,
    getListTitle,
  } = useInStoreLists()

  const firstElementRef = useRef<HTMLDivElement>(null)
  const lastElementRef = useRef<HTMLDivElement>(null)
  const [showUpNavigation, setShowUpNavigation] = useState(false)
  const [showDownNavigation, setShowDownNavigation] = useState(false)

  const handleItemDrop = (dropItem: DragData<ListsItem['waiting']>) => {
    const cutInLine = dropItem.index > 0

    moveWaitingListItemToInServiceList(cutInLine, dropItem.queueItem)
  }

  const handleInServiceItemClick = (
    clickedInServiceItemClick: ListsItem['inService']
  ) => {
    moveInServiceListItemToWaitingList(clickedInServiceItemClick)
  }

  useShowArrows({
    elementRef: firstElementRef,
    setShowNavigation: setShowUpNavigation,
    sellers: inServicePositions.length,
  })

  useShowArrows({
    elementRef: lastElementRef,
    setShowNavigation: setShowDownNavigation,
    sellers: inServicePositions.length,
  })

  return (
    <InStoreList
      className={csx({
        backgroundColor: 'white',
        paddingTop: '$space-0',
        paddingBottom: '$space-2',
        paddingLeft: '$space-1',
        paddingRight: '$space-2',
      })}
      onItemDrop={handleItemDrop}
      title={getListTitle(
        intl.messages.inService as string,
        inServicePositions
      )}
      data-testid="in-service-list"
      dndAccept={List.Waiting}
      showUpNavigation={showUpNavigation}
      showDownNavigation={showDownNavigation}
    >
      {inServicePositions.map((inServiceListItem, index) => {
        const ref =
          index === 0
            ? firstElementRef
            : index === inServicePositions.length - 1
            ? lastElementRef
            : null

        return (
          <InStoreListItem
            ref={ref}
            key={inServiceListItem.salesAssociate.id}
            index={index}
            item={inServiceListItem}
            onClick={handleInServiceItemClick}
            dndType={List.InService}
            avatarIconBgColor="NEED_PERFORMANCE_REVIEW_blue"
            testId="in-service-list-item"
          />
        )
      })}
    </InStoreList>
  )
}
